<template>
<div class='dataContainer'>
    <div>     
            <span class='Title' >Financiamiento</span>
            <br>
            <div class="input-group form-group">
                <span class="input-group-addon">Valor del Vehículo</span>
                <input type="text" size="10" class="form-control text-right" readonly="readonly" v-bind:value='ItemsDetail.currency_name + "$" + newInquiry.total_car_price | AddCommasToNumber' >
            </div>  
            <div class="input-group form-group">
                <span class="input-group-addon">Inicial</span>
                <input type="tel" class="form-control text-right"  @change='initial_payment_change'  v-on:keyup='initial_payment_change' v-bind:value='ItemsDetail.currency_name + "$" + newInquiry.initial_payment | AddCommasToNumber'  />
            </div>
            <div class="alert alert-danger mobileText" role="alert" v-if='!valid_finance_amount'>
                <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>                
                Valor de inicial es invalido
            </div>
            <div class="input-group form-group">
                <span class="input-group-addon">Monto a financiar</span>
                <input type="text" class="form-control text-right" readonly="readonly" v-bind:value='ItemsDetail.currency_name + "$" + newInquiry.finance_amount | AddCommasToNumber' />
            </div>
            <div class="input-group form-group">
                <span class="input-group-addon">Cuota Mensual</span>
                <input type="text" class="form-control text-right" readonly="readonly" v-bind:value='ItemsDetail.currency_name + "$" + newInquiry.monthly_payments_amount | AddCommasToNumber'  />        
            </div>
            <div class="row">
                <div class="col-xs-12 col-md-6" >  
                    <div class="input-group form-group">
                        <span class="input-group-addon">Banco</span>
                        <select class='form-control' v-on:change='bankChange' v-model='newInquiry.bank_id' >                    
                            <option v-for="bankDetail in bankListDetails" v-bind:value='bankDetail.id'  > {{bankDetail.name}} - {{ bankDetail.interest_rate }}% </option>
                        </select>
                    </div>
                </div>
                
                <div class="col-xs-12 col-md-6" >  
                    <div class="input-group form-group">
                        <span class="input-group-addon">Tiempo de financiamiento</span>
                        <select class="form-control" v-model='finance_length_years'  v-on:change='loanLengthChange' >
                            <option v-for="n in loanMaxLength" v-bind:value='n'  > {{ n }} {{ n == 1 ? 'Año' : 'Años' }}</option>
                        </select>
                    </div>
                    <!--
                    <div class="input-group form-group">
                        <span class="input-group-addon">Elige la Tasa de Interés</span>
                        <select class="form-control"  >
                            <option v-for="interest_rate in interest_rates" > {{ interest_rate }} </option>
                        </select>
                    </div>
                    -->
                </div>
                
            </div>            
            <!--          
            <div class="input-group form-group">
                <span class="input-group-addon">Agregar Más de Inicial?</span>
                <input type="text" class="form-control text-right"  v-on:keyup='initial_payment_added_keyup'  v-model='newInquiry.initial_payment_added' number />
            </div>                                                
            -->
            <!--
            <hr>
            <div class="input-group form-group">
                <span class="input-group-addon">Deseas tasar tu vehículo usado:</span>
                <select class="form-control" v-model='newInquiry.tasar_old_car'  v-on:change='tasar_old_car_change'>
                    <option value='0'>Selecionar</option>
                    <option value='1'>Si</option>
                    <option value='2'>No</option>
                </select>
            </div>
            <div class="input-group form-group" v-show='show_tasar_old_car'  >
                    <div class="row" >
                        <div class="col col-sm-12 col-md-5">
                            <label class='mobileText'>Marca</label>
                            <select class="form-control" v-model='newInquiry.old_car_brand' >                                                          
                                <option v-for="carBrandDetail in carBrandDetails" v-bind:value='carBrandDetail.id' :selected='carBrandDetail.id == 0'  > {{carBrandDetail.name}} </option>
                            </select>
                        </div>
                        <div class="col col-sm-12 col-md-4">
                            <label class='mobileText'>Modelo</label>
                            <input type="text"  class="form-control"  v-model='newInquiry.old_car_model' />
                        </div>
                        <div class="col col-sm-12 col-md-3">
                            <label class='mobileText'>A&ntilde;o</label>
                            <input type="text" class="form-control" v-on:keyup='old_car_year_keyup' v-model='newInquiry.old_car_year' />
                        </div>
                        <br/>
                    </div>
            </div>       -->
            
            <hr>                                    
            <!--
            <br><br>            
            <div class="input-group form-group">
                <span class="input-group-addon">Soy:</span>
                <select class="form-control" v-model='newInquiry.type_of_person' >
                    <option value='0'>Selecionar</option>
                    <option value='1'>Empresa</option>
                    <option value='2'>Persona</option>
                </select>
            </div>  
            --> 
            <!--
            <div>
                <span class='mobileText'>Nombre y Apellido</span><br><input class="form-control glow valin"           type="text"  v-model='completeName'      v-on:keyup='first_name_change'>
                <span class='mobileText'>Cedula</span><br><input class="form-control glow valin"                      type="text"  v-model='newInquiry.cedula' v-on:keyup='cedula_change'>
                <span class='mobileText'>Telefono(Movil o Casa)</span><br><input class="form-control glow valin"      type="tel"   v-model='newInquiry.phone1' v-on:keyup='phone1_change'>            
                <span class='mobileText'>Correo Electrónico (E-Mail)</span><br><input class="form-control glow valin" type="email" v-model='newInquiry.email'  v-on:keyup='email_change'>
                <br>          
                <InfoMessage></InfoMessage>                     
                <button class="btn btn-primary btn-block"  @click='validateFields' > ENVIAR SOLICITUD!</button>
                <br><br>
            </div>
            --> 
    </div>          
</div>
</template>

<script>
import { eventBus } from '../main';
import { CommonMixin } from './mixin/CommonMixin';

export default {  
  mixins : [CommonMixin],  
  data: function () {     
    return {
       bankListDetails: [],
       interest_rates: [],
       loan_max_length: 0,       
       newInquiry:{
            car_for_sale_id: 0,
            bank_id: 1, 
            currency_id: 0,
            interest_rate: 0,
            total_car_price: 0,
            initial_payment: 0,
            initial_payment_edited: false,
            initial_payment_added: 0,
            finance_amount: 0,
            finance_length_months: 1,  
            monthly_payments_amount: 0,
            type_of_person: 0,
            first_name: '',
            last_name: '',
            phone1: '',
            phone2: '000-000-0000',
            email:'',
            cedula: '',        
            tasar_old_car: 0,
            old_car_brand: 0,
            old_car_model: 'none',
            old_car_year:  '1900',
            priority: 99,            
       },
       finance_length_years: 1,
       carBrandDetails: [],
       show_tasar_old_car: false,
       gotData: false,
       completeName: '',
       valid_finance_amount:true,
    }
  },
  mounted: function () {        
    this.getBanks();
    this.getCarBrandDetails();
  },
  methods: {    
    validateFields: function(){
        eventBus.$emit('hide');

/*
        if(this.newInquiry.tasar_old_car == 0){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Deseas tasar tu vehículo usado:?"');
            return;
        }
        else if(this.newInquiry.tasar_old_car == 1)
        {            
            if(this.newInquiry.old_car_brand == 0){
                eventBus.$emit('genericMessage', false, 'Favor llenar "Marca del vehiculo"');
                return;
            }
            else if(this.newInquiry.old_car_model == ''){
                eventBus.$emit('genericMessage', false, 'Favor llenar "Modelo del vehiculo"');
                return;
            }
            else if(this.newInquiry.old_car_year == ''){
                eventBus.$emit('genericMessage', false, 'Favor llenar "Año del vehiculo"');
                return;
            }
        }        
  */      

        

        if(!this.valid_finance_amount){        
            eventBus.$emit('genericMessage', false, 'El inicial es mayor que el precio del vehiculo');
            return;
        }

        if(this.completeName == ''){        
            eventBus.$emit('genericMessage', false, 'Favor llenar "Nombre y Apellido"');
            return;
        }

        if(this.newInquiry.cedula == ''){
            eventBus.$emit('genericMessage', false, 'Favor llenar "Cedula"');
            return;
        }

        if(this.newInquiry.phone1 == ''){
            eventBus.$emit('genericMessage', false, 'Favor llenar "Telefono"');
            return;
        }

        if(this.newInquiry.email == ''){
            eventBus.$emit('genericMessage', false, 'Favor llenar "Correo Electronico"');
            return;
        }
         
        var nameArr = this.completeName.split(' ');          
        if(nameArr[0])
            this.newInquiry.first_name = nameArr[0];

        if(nameArr[1])
            this.newInquiry.last_name  = nameArr[1];        
        else
        {
            eventBus.$emit('genericMessage', false, 'Favor llenar "Apellido"');
            return;
        }

        if(nameArr[2])
            this.newInquiry.last_name  += ' ' + nameArr[2];        

        if(nameArr[3])
            this.newInquiry.last_name  += ' ' + nameArr[3];        
        
        this.newInquiry.finance_length_months = this.finance_length_years * 12;
        this.newInquiry.currency_id = this.ItemsDetail.currency_id;               

        this.$http.post('api/carinquiry/', this.newInquiry).then(response => {                        
            eventBus.$emit('resultMessage',response);                           
        }, response => {            
            eventBus.$emit('errorMsg',response);          
        });
    },    
    getBanks: function() {             
        this.$http.get('api/banks/maxresult/200').then(response => {                        
            this.bankListDetails = response.body;                                     

            this.gotData = true;
                        
            if(this.bankListDetails){                    
                
                if(this.bankListDetails[0])                
                    this.newInquiry.bank_id = this.bankListDetails[0].id;

                this.calculateAll();  
            }

        }, response => {
           eventBus.$emit('errorMsg',response);   
        });
    },       
    getCarBrandDetails: function() {             
        this.$http.get('api/carbrands/maxresult/200').then(response => {                        
            this.carBrandDetails = response.body;
            this.carBrandDetails.unshift({id:0,name:'Selecionar',"priority": 1,"active": 1})
            this.gotData = true;                     
            this.calculateAll();                            
        }, response => {            
            eventBus.$emit('errorMsg',response);
        });
    },    
    bankChange: function() {              
        this.calculateAll(true);
    },
    loanLengthChange: function(){
        this.calculateAll();                    
    },
    calculateAll: function(isBankChange){                
        this.bankListDetails.map((currentBank) => {
            if(currentBank.id == this.newInquiry.bank_id){
                console.log('currentBank:', currentBank);
                this.interest_rates = [];
                this.interest_rates.push(currentBank.interest_rate);

                //http://www.sb.gob.do/calculadora-de-prestamos-resultado
                
                this.newInquiry.interest_rate   = currentBank.interest_rate;
                                                
                this.newInquiry.car_for_sale_id = this.ItemsDetail.id;             
                this.newInquiry.total_car_price = this.ItemsDetail.offerprice;    
                
                if(!this.initial_payment_edited)
                    this.newInquiry.initial_payment = (this.newInquiry.total_car_price * (currentBank.initial_rate_year1 / 100)).toFixed(2);                

                this.loan_max_length            = currentBank.loan_max_length;                                    
                var monthlyInterestRate         = (currentBank.interest_rate/100/12);

                if(isBankChange){
                    this.finance_length_years = this.loan_max_length;
                }
                var numbersOfPayments           = this.finance_length_years * 12;

                if(this.newInquiry.initial_payment > this.newInquiry.total_car_price){
                    this.newInquiry.finance_amount  = '0.00';
                    this.newInquiry.monthly_payments_amount = '0.00';
                    this.valid_finance_amount = false;
                }
                else {
                    const cInterestRate = currentBank.interest_rate / 100;
                    const FinanceAmount = (this.newInquiry.total_car_price - (parseFloat(this.newInquiry.initial_payment) + parseFloat(this.newInquiry.initial_payment_added)));//.toFixed(2);                                                                                   
                    this.newInquiry.finance_amount  = FinanceAmount;
                    const GastoDeCierre = 0.07;
                    const FinanceAmountWithGastoDeCierre = (FinanceAmount * GastoDeCierre) + FinanceAmount;
                    const FinanceAmountWithInterest = FinanceAmountWithGastoDeCierre * cInterestRate;
                    //console.log('FinanceAmount:', FinanceAmount);
                    //console.log('FinanceAmountWithGastoDeCierre:', FinanceAmountWithGastoDeCierre);
                    this.newInquiry.monthly_payments_amount = (((FinanceAmountWithInterest * (numbersOfPayments / 12))  + FinanceAmountWithGastoDeCierre) / numbersOfPayments).toFixed(2);
                    //this.newInquiry.monthly_payments_amount = (monthlyInterestRate * -FinanceAmountWithGastoDeCierre * Math.pow((1 + monthlyInterestRate), numbersOfPayments) / (1 - Math.pow((1 + monthlyInterestRate), numbersOfPayments))).toFixed(2);
                    this.valid_finance_amount = true;
                }                                        
            }
        });
    },
    initial_payment_added_keyup: function(e){   

        if(e.target.value)               
            this.newInquiry.initial_payment_added = e.target.value.replace(/\D/.g,'');                            
        else
            this.newInquiry.initial_payment_added = 0;

        this.calculateAll();                            
    },
    old_car_year_keyup : function(e){
        this.newInquiry.old_car_year = this.getNumericIntOnly(e.target.value);
    },
    first_name_change : function(e){

    },
    cedula_change : function(e){
        this.newInquiry.cedula = this.getNumericWithDashOnly(e.target.value);
    },
    phone1_change : function(e){
        this.newInquiry.phone1 = this.getNumericWithDashOnly(e.target.value);
    },
    initial_payment_change : function(e){                     
        if(e.keyCode == 37 || e.keyCode == 39)  //left and right arrow
            return;        

        this.initial_payment_edited = true;        
        this.newInquiry.initial_payment = ''; 
        var newVal = this.getNumericIntDotOnly(e.target.value);

        if(newVal.length == 0){
            this.newInquiry.initial_payment = '0'; 
            this.newInquiry.initial_payment = ''; 
            this.newInquiry.finance_amount  = '0.00';
            this.newInquiry.monthly_payments_amount = '0.00';
            this.valid_finance_amount = false;
        }else{            
            this.newInquiry.initial_payment = newVal;            
            this.calculateAll();                            
        }                        
    },
    email_change : function(e){

    },
    tasar_old_car_change: function() {
        if(this.newInquiry.tasar_old_car == 1)
            this.show_tasar_old_car = true;
        else
            this.show_tasar_old_car = false;
    }
  },  
  filters: {
     
  },
  computed: {
    loanMaxLength: function() {        
        var result = [];
        for(var i = 1; i <= this.loan_max_length; i++){
            result.push(i);
            this.finance_length_years = i;
        }        
        return result;
    }
  },
  props:['ItemsDetail']
  
}
</script>

<style scoped>
   .Title {    
        color: red;
        font-size:1.7em;        
   }

   .IndexWidth {
        display:inline-block;
        width:50px;
        padding-left: 10px;
   }
   
   .btnWidth{
        width:50px;
        margin-left: 10px;  
        display:inline-block;      
   }

   .glyphiconSize{
       font-size: 1.4em;
   }

   @media screen and (max-width: 981px) {  
       .Title {    
            font-size:3em;
       }
        input {        
            position:relative;
            width:100%;
            height:100px;
            font-size: 3em;            
        }

        select {        
            position:relative;
            width:100%;
            height:100px;
            font-size: 2em;            
        }

        .input-group-addon {                    
            font-weight: 200;
            font-size: 3em;                        
        }

        button {        
            position:relative;
            width:100%;
            height:100px;
            font-size: 3em;            
        }

        .mobileText {
            font-size: 3em;            
        }
   }

  @media screen and (min-width: 981px) {          
        .mobileText {
            font-weight: 200;
        }
        .dataContainer{
            font-size:1.7em;        
        }   

       input {        
            position:relative;
            width:100%;
            height:50px;
            font-size: 1em;            
        }

        select {        
            position:relative;
            width:100%;
            height:50px;
            font-size: 1em;            
        }

        .input-group-addon {                    
            font-weight: 200;
            font-size: 1em;                        
        }

        button {        
            position:relative;
            width:100%;
            height:50px;
            font-size: 1em;            
        }
   }
      
</style>



// WEBPACK FOOTER //
// InquiryCalculator.vue?e91cfe78